<template>
  <tr>
    <td class="chart-rank">#{{ rank }}</td>
    <td class="chartColor"><div class="chartColor__box" :class="chartColorClass">&nbsp;</div></td>
    <td class="pieTable__key">{{ productName }}</td>
    <td class="pieTable__value">{{ product.units }}</td>
  </tr>
</template>

<script>
  import lodash from 'lodash';

  export default {
    name: 'Product',
    props: ['rank', 'product'],
    computed: {
      chartColorClass() {
        return `chartColor__box--${this.vendor}`;
      },
      vendor() {
        return lodash.capitalize(this.product.vendor);
      },
      productName() {
        return this.product.product;
      },
      units() {
        return this.product.units;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .chart-rank {
    color: $dove-grey;
    font-size: em(14px);
    width: 22px;
  }

  .pieTable__value {
    text-align: right;
    color: $dove-grey;
    font-weight: 600;
  }

  .pieTable__key {
    color: $dove-grey;
  }

  .chartColor {
    @include e(box) {
      width: 11px;
      height: 11px;
      border-radius: 100%;
      border: none;

      @include m(Oticon) {
        background: $color-vendor-oticon;
      }

      @include m(Phonak) {
        background: $color-vendor-phonak;
      }

      @include m(Resound) {
        background: $color-vendor-resound;
      }

      @include m(Widex) {
        background: $color-vendor-widex;
      }

      @include m(Unitron) {
        background: $color-vendor-unitron;
      }

      @include m(Sonic) {
        background: $color-vendor-sonic;
      }

      @include m(Signia) {
        background: $color-vendor-signia;
      }
    }
  }
  td {
    text-align: left;
    padding: 4px;
  }
</style>
